import axios from 'axios';

let cachedToken = null;
let cachedTokenExpiration = null;

export async function getToken() {
    const now = Date.now();

    // Se abbiamo un token valido in cache, lo restituiamo
    if (cachedToken && cachedTokenExpiration && now < cachedTokenExpiration) {
        return cachedToken;
    }

    // Altrimenti, ne otteniamo uno nuovo e lo memorizziamo
    const user = window.firebase.auth().currentUser;
    if (!user) throw new Error("User not logged in");

    const token = await user.getIdToken(true); // `true` forza il refresh
    const expirationTime = now + 60 * 60 * 1000; // 1 ora in ms

    cachedToken = token;
    cachedTokenExpiration = expirationTime;

    return token;
}

export function doGet(url, params) {
    return new Promise((resolve, reject) => {
        getToken()
            .then((token) => {
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };
                const apiUrl = process.env.REACT_APP_API_URL;

                axios.get(apiUrl + url, {
                    headers: headers,
                    params: params,
                    paramsSerializer: params => {
                        return Object.entries(params)
                            .map(([key, value]) => {
                                if (Array.isArray(value)) {
                                    return value.map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&');
                                }
                                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                            })
                            .join('&');
                    }
                })
                    .then(response => {
                        if (response.status === 200) {
                            const res = response.data;
                            if (res && res.success) {
                                resolve(res.data || res);
                            } else {
                                console.error('API Error:', res?.message || 'Unknown error');
                                reject(new Error(res?.message || 'Request failed'));
                            }
                        } else {
                            console.error('Unexpected status code:', response.status);
                            reject(new Error(`Unexpected status code: ${response.status}`));
                        }
                    })
                    .catch(error => {
                        console.error('Request failed:', error);
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            console.error('Response data:', error.response.data);
                            console.error('Response status:', error.response.status);
                            console.error('Response headers:', error.response.headers);
                            reject(new Error(`Request failed with status ${error.response.status}: ${error.response.data?.message || 'No error details'}`));
                        } else if (error.request) {
                            // The request was made but no response was received
                            console.error('No response received:', error.request);
                            reject(new Error('No response from server'));
                        } else {
                            // Something happened in setting up the request
                            console.error('Request setup error:', error.message);
                            reject(error);
                        }
                    });
            })
            .catch(error => {
                console.error('Failed to get auth token:', error);
                reject(new Error('Authentication failed'));
            });
    });
}

export function doPost(url, data) {

    return new Promise((resolve, reject) => {
        getToken()
            .then((token) => {
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };
                const apiUrl = process.env.REACT_APP_API_URL;

                return axios.post(apiUrl + url, data, { headers: headers })
                    .then(response => {
                        if (response.status === 200) {
                            const res = response.data;
                            if (res.success) {
                                resolve(res.data);
                            } else {
                                console.error('API Error:', res.message);
                                reject(new Error(res.message || 'Unknown error occurred'));
                            }
                        } else {
                            console.error('Unexpected status code:', response.status);
                            reject(new Error(`Unexpected status code: ${response.status}`));
                        }
                    });
            })
            .catch(error => {
                console.error('Request failed:', error);
                if (error.response) {
                    console.error('Response data:', error.response.data);
                    console.error('Response status:', error.response.status);
                    reject(new Error(error.response.data?.message || `Request failed with status ${error.response.status}`));
                } else if (error.request) {
                    console.error('No response received:', error.request);
                    reject(new Error('No response from server'));
                } else {
                    console.error('Request setup error:', error.message);
                    reject(error);
                }
            });
    });
}